import { architeckCall } from 'database';
import moment from 'moment';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, CardText, CardTitle, Col, Container, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';
import keys from 'keys';

class Profile extends React.Component {

    state = {
        loaded: false,
        bugs: [],
        canSave: true
    }

    componentWillMount = async () => {

        const bugs = await architeckCall({
            method: 'get',
            url: `/api/v1/bugs/list?find_by=company__${this.props.viewing_user.company._id}`
        })

        if(bugs.success) {

            this.setState({bugs: bugs.data, loaded: true})

        } else {

            toggleAlert(true, 'danger', `Something went wrong fetching your submitted bugs.`, 'infinite' )
            console.log(bugs);

        }


    }
    
    render() {

        const bugs = this.state.bugs

        return (
            <>

            <Container>     

                <Helmet>
                    <title>Bugs</title>
                    <meta name="description" content="Bugs" />
                </Helmet>

                {this.state.alert}

                <Card className="mt-4 ">

                    <CardHeader>
                        <h2 className="mb-0">Submitted Bugs</h2>
                    </CardHeader>

                    <CardBody>
                        <Row>
                            <Col lg={2}>
                                <img className="w-100" src={require('assets/img/misc/Bugs.svg')} alt="..." />
                            </Col>
                            <Col lg={10}>
                                <h4  className="mt-2 mt-lg-0">For when things go wrong.</h4>
                                <p>On this page you can view all of your companies previously submitted application bugs. If you would like to submit a new on you may do so under the Bugs tab on the project you would like to submit a bug for.</p>
                            </Col>
                        
                        </Row>

                    </CardBody>
                </Card>

                {this.state.loaded ? (
                    <>
                        <hr />

                        <Row >

                            {bugs.length ? bugs.map((p, i) => (
                                <Col key={p._id} xl={11} className={i % 2  ? "offset-lg-1" : null}>
                                        <Card className="mb-4">
                                            <CardHeader className="">
                                                <h2 className="mb-0">{ moment.unix(p.created_at).format("MM/DD/YYYY")}</h2>
                                                <h5 className="text-muted mb-0">
                                                    Status: 
                                                    <b className={p.status === 'open' ? 'text-uppercase text-danger' : p.status === 'correcting' ? 'text-uppercase text-info' : 'text-uppercase text-success'}> {p.status}
                                                    </b>
                                                </h5>

                                                <hr className="my-2 mb-3 mx--4"/>

                                                <h5 className="text-muted mb-0">
                                                    <b style={{display: 'inline-block', width: 105}}>Error Type:</b> {p.type}
                                                </h5>
                                                <h5 className="text-muted mb-0">
                                                    <b style={{display: 'inline-block', width: 105}}>Time Of Error:</b> {p.time_of_error}
                                                </h5>
                                                <h5 className="text-muted mb-0">
                                                    <b style={{display: 'inline-block', width: 105}}>Error Message:</b> {p.error_message}
                                                </h5>
                                                <h5 className="text-muted mb-0">
                                                    <b style={{display: 'inline-block', width: 105}}>Submitted By:</b>  {p.user.given_name}{' '}{p.user.family_name}
                                                </h5>

                                            </CardHeader>
                                            <CardBody>

                                                <CardTitle className="mb-1">
                                                    Message:
                                                </CardTitle>

                                                <CardText>
                                                    {p.description}
                                                </CardText>

                                                {p.response && (
                                                    <>
                                                    <CardTitle className="mb-1">
                                                        Response:
                                                    </CardTitle>

                                                    <CardText>
                                                        {p.response}
                                                    </CardText>
                                                    </>
                                                )}
                                            
                                            </CardBody>
                                        </Card>
                                </Col>
                            )): (
                                <Col xs={12}>
                                    <Card>
                                        <CardBody>
                                            <h2 className="mb-0">Your company has not submitted any project bugs.</h2>
                                        </CardBody>
                                    </Card>
                                </Col>

                            )}
                        </Row>

                        <hr className="mt-0"/>
                    </>
                ) : null}

            </Container>
            </>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
  
    };
};
  
export default connect(mapStateToProps, '')(Profile);